module.exports = __webpack_public_path__ + "static/media/lunar-bg.9cc250cd.jpg";